module.exports = __webpack_public_path__ + "img/faresoner.f06dd05a.jpg";